var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    rx: 20,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.452 37.5244H62.0544C43.1246 37.5244 32.5709 44.0571 32.5709 62.987V144.065C32.5709 162.995 33.7436 167.518 52.6735 167.518H140.452C159.382 167.518 162.564 162.995 162.564 144.065V62.987C162.564 44.0571 159.382 37.5244 140.452 37.5244Z",
    fill: "#001E36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6366 120.731H100.927V131.465H62.6826V73.5801H76.6366V120.731ZM132.216 100.574L127.804 100.257C123.589 100.257 120.885 101.582 119.694 104.233V131.465H106.296V88.4481H118.859L119.296 93.9753C121.548 89.7607 124.688 87.6534 128.718 87.6534C130.15 87.6534 131.394 87.8133 132.455 88.1307L132.216 100.574Z",
    fill: "#31A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightrome);
export default __webpack_public_path__ + "static/media/lightrome.efcc61c1760fd2ef14b88c909470edbf.svg";
export { ForwardRef as ReactComponent };